<div id="managePopUp">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{authoringContentData?.individualAlertModalHeading}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="discardChanges()">
                <span aria-hidden="true">&times;</span>
              </button>
    </div>
    <div class="modal-body">

        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <p class="m-b-15">{{authoringContentData?.individualAlertModalbody}}</p>

            </div>
        </div>

    </div>

    <div class="modal-footer">      
        <button type="button" class="btn secondary_btn order-sm-1 " (click)="discardChanges()"> {{authoringContentData?.individualAlertModalCancelBtn}} </button>

        <button type="button" class="btn primary_btn " 
        (click)="overrideChanges()" > {{authoringContentData?.individualAlertModalContinueBtn}} </button>
        
      </div>
</div>